import type React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { RegistersPageView } from './RegistersPageView';
import { useRegistersPage } from './useRegistersPage';

/**
 * `/accounting/registers` — the tab shell every `/accounting/registers*` URL
 * renders.
 *
 * The experiment's third grouping: the subledgers. Each tab is a register of
 * things that exist — assets, employees, shareholders — plus the runs that post
 * them into the ledger. Each owns its data and its own `ErrorBoundary`, so this
 * shell holds neither.
 *
 * Readiness is **not** uniform across these three: fixed assets reads the live
 * ledger, while payroll and dividends still run on seeded services and refuse
 * to post. That is stated per tab, by the pages themselves, rather than
 * flattened into a label here.
 */
export const RegistersPage: React.FC = () => {
    const page = useRegistersPage();

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestIdProp('registers-page')}
        >
            <RegistersPageView
                selectedTabId={page.selectedTabId}
                tabs={page.tabs}
            />
        </div>
    );
};
